export default "__VITE_ASSET__CrcRwP3P__"